import { render } from "./image-file-loader.vue?vue&type=template&id=d1036dfc&scoped=true"
import script from "./image-file-loader.vue?vue&type=script&lang=js"
export * from "./image-file-loader.vue?vue&type=script&lang=js"

import "./image-file-loader.vue?vue&type=style&index=0&id=d1036dfc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d1036dfc"

export default script